const RESOURCE_TYPE = 'scratch-gui/resource/RESOURCE_TYPE';
const UPDATE_RESOURCE_LIST = 'scratch-gui/resource/UPDATE_RESOURCE_LIST';
const UPDATE_RESOURCE_SELECTED = 'scratch-gui/resource/UPDATE_RESOURCE_SELECTED';

const initialState = {
    resourceType: '',
    resourceSet: {},
    selectedResourceSet: {},
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
        case RESOURCE_TYPE:
            return Object.assign({}, state, {
                resourceType: action.value
            });
        case UPDATE_RESOURCE_LIST:
            return Object.assign({}, state, {
                resourceSet: action.value
            });
        case UPDATE_RESOURCE_SELECTED:
            return Object.assign({}, state, {
                selectedResourceSet: action.value
            });
        default:
            return state;
    }
};

const setResourceType = value => ({
    type: RESOURCE_TYPE,
    value: value
})

const setReourceSelectedList = value => ({
    type: UPDATE_RESOURCE_SELECTED,
    value: value
});

const setReourceList = value => ({
    type: UPDATE_RESOURCE_LIST,
    value: value
});

export {
    reducer as default,
    initialState as resourceInitialState,
    setResourceType,
    setReourceSelectedList,
    setReourceList
};
